import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";
import * as yup from "yup";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import {
  selectCheckoutInfo,
  selectCheckoutShipping,
} from "../../redux/checkout/checkout.selectors";
import { checkoutActions } from "../../redux/checkout/checkout.reducer";
import { CheckoutShipping } from "../../redux/checkout/checkout.types";

import useStyles from "./checkout-shipping.styles";

import withAuth from "../../hocs/withAuth";

import CheckoutLinks from "../../components/checkout-links";
import CheckoutSummary from "../../components/checkout-summary";
import StripeIcon from "../../assets/icons/stripe-icon";
import Loading from "../../components/loading";

const PriceField = (props: any) => {
  const {
    values: { method },
    touched,
    setFieldValue,
  } = useFormikContext<CheckoutShipping>();

  const ShippingMethod: {
    [name: string]: number;
  } = {
    orderOver$39: 0,
    twoDaysExpress: 12,
  };

  useEffect(() => {
    setFieldValue(props.name, ShippingMethod[method]);
    props.submitCheckoutShipping({
      method,
      price: ShippingMethod[method],
    });
  }, [method, touched.method, setFieldValue, props.name]);

  return null;
};

const CheckoutShippingPage = ({
  checkoutRoutes,
}: {
  checkoutRoutes: string[];
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const checkoutShipping = useSelector(selectCheckoutShipping);
  const { contact, shippingAddress } = useSelector(selectCheckoutInfo);
  const { email } = contact;
  const { line1, line2, country, state, city, postal_code } = shippingAddress;
  const [isLoading, setIsLoading] = useState(true);
  const matches = useMediaQuery("(min-width:1200px)");
  const classes = useStyles({ matches });

  const initialValues = checkoutShipping;

  const validationSchema = yup.object().shape({
    method: yup.string().required("Required"),
    price: yup.number().required("Required").min(0),
  });

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);

    window.scrollTo({
      top: 0,
    });
  }, []);

  const sleep = (milliseconds = 1000) =>
    new Promise((resolve) => setTimeout(resolve, milliseconds));

  const submitCheckoutShipping = (values: CheckoutShipping) =>
    dispatch({
      type: checkoutActions.submitShipping.type,
      payload: values,
    });

  const onSubmit = async (values: CheckoutShipping, actions: any) => {
    setIsLoading(true);
    await sleep();
    // alert(JSON.stringify(values, null, 2));
    actions.setSubmitting(false);
    setIsLoading(false);
    history.push("payment");
  };

  return (
    <div className={classes.container}>
      <Link to="/" className={classes.logo}>
        LOGO
      </Link>
      <div className={classes.subContainer}>
        <CheckoutLinks checkoutRoutes={checkoutRoutes} />
        <div className={classes.previousProcessContainer}>
          <div className={classes.previousProcess}>
            <span>Contact</span>
            <span>{email}</span>
            <Link to="information">Change</Link>
          </div>
          <div className={classes.previousProcess}>
            <span>Ship to</span>
            <span>
              {line1 && `${line1}, `}
              {line2 && `${line2}, `}
              {city && `${city}, `}
              {state && `${state}, `}
              {postal_code && `${postal_code}, `}
              {country && `${country}`}
            </span>
            <Link to="information">Change</Link>
          </div>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {(props) => {
            // console.log(props);
            return (
              <Form className={classes.formContainer}>
                <div className={classes.fieldsContainer}>
                  <div className={classes.fieldsHeader}>
                    <div className={classes.fieldsHeaderTitle}>
                      Shipping method
                    </div>
                    <ErrorMessage
                      name="method"
                      component="span"
                      className={classes.errorMessage}
                    />
                  </div>
                  <div className={classes.fieldsBody}>
                    <div
                      role="group"
                      aria-labelledby="my-radio-group"
                      className={classes.radioGroup}
                    >
                      <label className={classes.label}>
                        <Field
                          type="radio"
                          name="method"
                          value="orderOver$39"
                        />
                        <span>
                          <span></span>
                        </span>
                        <span>Order over $39</span>
                        <span>FREE</span>
                      </label>
                      <label className={classes.label}>
                        <Field
                          type="radio"
                          name="method"
                          value="twoDaysExpress"
                        />
                        <span>
                          <span></span>
                        </span>
                        <span>2 Days Express</span>
                        <span>CAD $12</span>
                      </label>
                    </div>
                  </div>
                </div>
                <PriceField
                  name="price"
                  submitCheckoutShipping={submitCheckoutShipping}
                />
                <div className={classes.btnContainer}>
                  <StripeIcon height="0" />
                  <button type="submit" className={classes.continueBtn}>
                    Continue to Payment
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <CheckoutSummary />
      <Loading size="3rem" fullScreen on={isLoading} />
    </div>
  );
};

export default withAuth(CheckoutShippingPage);
